import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '名称',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'type',
        fieldName: '类型',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'PaymentCycleType',
          pickerType: '',
          filterable: true,
          selectType: 1// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'day',
        fieldName: '票到天数',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'mark',
        fieldName: '备注',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }
    ]
  }
]
